import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getLocationsAdmin, putLocationAdmin } from '../../actions/location'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";

// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SimpleForm from "components/SimpleForm/SimpleForm.jsx";

import { locationFields } from "variables/variables.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: {},
      locations: [],
    };
    this.handleLocationEditSubmit = this.handleLocationEditSubmit.bind(this);
    this.handleLocationEditChange = this.handleLocationEditChange.bind(this);
    this.handleLocationEditCancel = this.handleLocationEditCancel.bind(this);
  }

  handleLocationEditSubmit(){
    
    this.props.dispatchPutLocationAdmin(this.props.auth.user, this.state.edit)
    .then( res => {
      return this.props.dispatchGetLocationsAdmin(this.props.auth.user);
    })
    .then( locations => {
      this.setState({edit:{}});
      this.setState({locations});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });

  }

  handleLocationEditChange(e, stateName, type, stateNameEqualTo){
    let value = e.target.value;
    if(e.target.type==="checkbox"){
      value = e.target.checked;
    }
    this.setState({edit:{ ...this.state.edit, [e.target.name]: value }});
    
  }

  handleLocationEditCancel(){
      this.setState({edit:{}});    
  }

  
  handleTableAction(action, id){
    if(action==="delete"){
    }  
    if(action==="edit"){
      var item = this.state.locations.find(function(i) {
        return i.id === id;
      });
      item.available = (item.available===1)?true:false;
      this.setState({editId: Date.now()});

      this.setState({edit:item});
    }
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  
  componentDidMount() {
    this.props.dispatchGetLocationsAdmin(this.props.auth.user)
    .then( locations => {
      this.setState({locations});
    });   
  }
  render() {
    const {  translate, classes } = this.props;

    var tableData = [];
    if(this.state.locations.length>0){
      this.state.locations.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
          { color: "success", icon: Edit, action: "edit" },
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        tableData.push([prop.id, prop.username, prop.nickname, prop.addressCity, prop.addressProvince, fillButtons]);
        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}  
          <SimpleForm 
            fields={[...locationFields.step3,...locationFields.step1,...locationFields.step2]}
            editId={this.state.editId} 
            state={this.state.edit} 
            open={this.state.edit.id?true:false}
            classes={classes}
            onChange={this.handleLocationEditChange} 
            onSubmit={this.handleLocationEditSubmit}
            onCancel={this.handleLocationEditCancel}
          />                
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.admin_locations.content")} /> 
          </ItemGrid>                
          <ItemGrid xs={12} sm={12} md={12}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="Locations"
              content={
                <Table
                  tableHead={[
                    "Id",
                    "User",
                    "Nickname",
                    "City",
                    "Province",
                    "Actions"
                  ]}
                  tableData={tableData}
                />
              }
            />
          </ItemGrid>                    
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetLocationsAdmin: (user) => getLocationsAdmin(user),
  dispatchPutLocationAdmin: (user, data) => putLocationAdmin(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Locations);



// WEBPACK FOOTER //
// ./src/views/Admin/Locations.jsx